const styles = {
  label: {
    minWidth: 150,
  },
};

export default styles;
